import React from "react";
import { Caption1 } from "@activecollab/components";

const TermsAndConditions = () => {
  return (
    <div className="tw-flex tw-justify-center tw-mt-3">
      <Caption1 color="tertiary">
        By signing up you are agreeing to the ActiveCollab{" "}
        <a
          href="https://activecollab.com/terms"
          target="_blank"
          rel="noreferrer"
          className="tw-no-underline hover:tw-underline"
          key="Terms of Service"
        >
          Terms of Service
        </a>{" "}
        and{" "}
        <a
          href="https://activecollab.com/privacy-policy"
          target="_blank"
          rel="noreferrer"
          className="tw-no-underline hover:tw-underline"
          key="Privacy Policy"
        >
          Privacy Policy
        </a>
      </Caption1>
    </div>
  );
};

export default TermsAndConditions;
